import React from 'react';
import { DOMAIN_CONFIG } from '../config';
import { ShieldAlert, Mail, ArrowUp, Cookie } from 'lucide-react';
import { useConsent } from '../context/ConsentContext';

export const Footer: React.FC = () => {
  const { openSettings } = useConsent();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="pt-16 pb-12 border-t border-slate-800/80 bg-[#03060f] text-slate-400 text-xs">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 pb-10 border-b border-slate-800/80">
          <div>
            <div className="flex items-center gap-2 mb-2">
              <span className="font-mono font-bold text-lg text-white">
                {DOMAIN_CONFIG.domainName}
              </span>
              <span className="px-2 py-0.5 rounded-full bg-emerald-950/60 border border-emerald-500/30 text-emerald-400 text-[10px] font-mono uppercase">
                Market Valuation Phase
              </span>
            </div>
            <p className="text-slate-400 text-sm max-w-md">
              The premier domain name opportunity for modern IT consulting, cloud infrastructure, and developer engineering platforms.
            </p>
          </div>

          <div className="flex items-center gap-4">
            <a
              href={`mailto:${DOMAIN_CONFIG.sellerEmailFallback}?subject=Inquiry%20regarding%20${DOMAIN_CONFIG.domainName}`}
              className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-xl bg-slate-900 border border-slate-800 hover:border-slate-700 text-slate-300 hover:text-white transition-colors text-xs font-medium"
            >
              <Mail className="w-3.5 h-3.5 text-emerald-400" />
              <span>Direct Email Inquiries</span>
            </a>

            <button
              onClick={scrollToTop}
              className="p-2.5 rounded-xl bg-slate-900 border border-slate-800 hover:border-slate-700 text-slate-400 hover:text-white transition-colors"
              title="Back to top"
            >
              <ArrowUp className="w-4 h-4" />
            </button>
          </div>
        </div>

        {/* Private Asset & Market Interest Notice */}
        <div className="mt-8 p-5 rounded-2xl bg-slate-950/80 border border-slate-900 text-[11px] leading-relaxed text-slate-400 space-y-2">
          <div className="flex items-center gap-1.5 text-slate-300 font-semibold">
            <ShieldAlert className="w-3.5 h-3.5 text-emerald-400" />
            <span>Digital Asset & Market Interest Notice</span>
          </div>
          <p>
            {DOMAIN_CONFIG.domainName} is a privately registered Internet domain name. This website is currently published to assess market acquisition interest and indicative valuation. All inquiries and offers submitted are non-binding expressions of interest. The domain owner reserves full discretion and the right not to accept any offer, counter any offer, or choose not to sell the domain at the conclusion of this process.
          </p>
          <p className="text-slate-500">
            Should an agreement be reached, all transfers and escrow settlements are conducted through accredited, third-party licensed escrow platforms ensuring full security for both parties.
          </p>
        </div>

        <div className="mt-6 flex flex-col sm:flex-row items-center justify-between gap-4 text-slate-500">
          <div className="flex flex-wrap items-center gap-3">
            <p>© {new Date().getFullYear()} {DOMAIN_CONFIG.domainName}. All rights reserved.</p>
            <span className="hidden sm:inline text-slate-700">•</span>
            <button
              type="button"
              onClick={openSettings}
              className="inline-flex items-center gap-1.5 text-slate-400 hover:text-emerald-400 transition-colors cursor-pointer text-[11px]"
            >
              <Cookie className="w-3.5 h-3.5" />
              <span>Cookie Settings</span>
            </button>
          </div>
          <p className="font-mono text-[11px]">
            High-Performance Edge Architecture • Private Asset Showcase
          </p>
        </div>
      </div>
    </footer>
  );
};
